import { useEffect, useState } from "react";

import { getItem } from "../../api/generics";
import { SUCCESS } from "../../utils/constants/tags";
import InventoryLocation from "../../models/inventory-location";
import { formatToCurrencyRounded } from "../../currency/format";
import { PYG } from "../../currency/available-currencies";

interface AsyncInventoryLocationValueProps {
  storeId: number;
}

const AsyncInventoryLocationValue: React.FC<
  AsyncInventoryLocationValueProps
> = ({ storeId }) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [inventory, setInventory] = useState<InventoryLocation | undefined>(
    undefined
  );

  const fetchStoreLocation = async () => {
    const locationStatus = await getItem<InventoryLocation>(
      `/inventory_locations/from_store/${storeId}/`
    );
    if (locationStatus.status === SUCCESS) {
      if (locationStatus.data !== undefined) {
        setInventory(locationStatus.data);
      }
    } else {
      setInventory(undefined);
    }
  };

  const getInitialValues = async () => {
    setLoading(true);

    const locationPromise = fetchStoreLocation();
    await locationPromise;

    setLoading(false);
  };

  useEffect(() => {
    getInitialValues();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return <p>Cargando...</p>;
  }

  if (inventory === undefined) {
    return <p>No se encontró el valor</p>;
  }

  return (
    <b>
      {inventory?.inventoryProductionCostValue
        ? formatToCurrencyRounded(inventory.inventoryProductionCostValue, PYG)
        : "-"}
    </b>
  );
};

export default AsyncInventoryLocationValue;
